import { render, staticRenderFns } from "./OverviewOpportunity.vue?vue&type=template&id=19d1d615&"
import script from "./OverviewOpportunity.vue?vue&type=script&lang=js&"
export * from "./OverviewOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports